var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_2",
    "data-name": "Camada 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1176.61 416.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-2 {\n        letter-spacing: 0em;\n      }\n\n      .cls-3 {\n        font-family: MenckenStdText-ExtraBold, 'Mencken Std Text';\n        font-size: 142.23px;\n        font-weight: 700;\n      }\n\n      .cls-3, .cls-4, .cls-5 {\n        fill: #1d1d1b;\n      }\n\n      .cls-6 {\n        letter-spacing: 0em;\n      }\n\n      .cls-7 {\n        letter-spacing: 0em;\n      }\n\n      .cls-4 {\n        font-family: MenckenStdText-Regular, 'Mencken Std Text';\n        font-size: 150.14px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(381.28 173.06)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "HELP D"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 522.56,
    y: 0
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 609.61,
    y: 0
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 688.84,
    y: 0
  }, "K")), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(381.28 325.98) scale(1.15 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "I"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 48.49,
    y: 0
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    x: 132.58,
    y: 0
  }, "SJE")), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m251.28,193.29l18.98-18.98-85.88-85.88,1.98,185.71,87.41,73.47c-37.96,41.52-80.78,60.71-102.95,68.93-22.16-8.22-64.98-27.41-102.93-68.93l87.41-73.47,1.98-185.71-85.88,85.88,18.98,18.98,39.35-39.35-1.14,107.57-77.75,65.33C1.93,260.38-1,188.23.19,156.85c.41-10.66.66-21.32.66-31.99V32.65c0-.74.43-1.4,1.12-1.67C22.81,22.53,48.73,13.94,79.14,7.95,114.56.97,145.92-.48,170.83.12c24.91-.6,56.29.85,91.71,7.83,30.38,5.99,56.33,14.58,77.15,23.03.68.27,1.12.93,1.12,1.67v92.2c0,10.68.27,21.34.66,31.99,1.2,31.38-1.73,103.52-50.65,169.99l-77.75-65.33-1.14-107.57,39.35,39.35Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7ca598253074ce90bef0c19e1f3c335d.svg";
export { ForwardRef as ReactComponent };